import PropTypes from 'prop-types';

import { Container, HighlightedBar } from './Callout.styles';

import { FormattedTitle } from '../../../components/FormattedTitle/FormattedTitle';

export const Callout = ({ message }) => (
  <Container>
    <HighlightedBar component="span" />
    <FormattedTitle
      level={3}
      variant="smallBold"
      color="focus90"
      dirtyTitle={message}
    />
  </Container>
);

Callout.propTypes = {
  message: PropTypes.string.isRequired
};
